import React from 'react';

import lbbImg from '~/assets/images/home/testimonials/lbb.png';
import swiggyImg from '~/assets/images/home/testimonials/swiggy.png';
import unacademyImg from '~/assets/images/home/testimonials/unacademy.png';
import maheshImg from '~/assets/images/home/testimonials/mahesh.png';
import dhruvImg from '~/assets/images/home/testimonials/dhruv.png';
import anujImg from '~/assets/images/home/testimonials/anuj.png';

export const userTestimonials = [
  {
    name: 'Mahesh',
    designation: 'HR',
    companyName: 'Unacademy',
    testimonialText:
      'Upraised has a uniquely novel approach to up-skilling PM professionals. We felt that they understand the modern day skills needed to excel as a PM, and they go the extra mile to ensure that the candidates land their dream jobs.',
    userAvatar: maheshImg,
    companyLogo: unacademyImg,
    background: 'linear-gradient(90deg, #1762CD 0.71%, rgba(45, 129, 247, 0.6) 100%)',
  },
  {
    name: 'Dhruv',
    designation: 'Founder',
    companyName: 'LBB',
    testimonialText:
      "Manan has been a fantastic addition to our product team - from day one, he's been speaking with customers, learning everything he can, and getting projects executed super fast. Within 6 months he has scaled a product driven revenue line from scratch to a meaningful contribution to the company.",
    userAvatar: dhruvImg,
    companyLogo: lbbImg,
    background: 'linear-gradient(90deg, #1B7D81 0.71%, rgba(50, 171, 176, 0.6) 100%)',
  },
  {
    name: 'Anuj',
    designation: 'Head of Product',
    companyName: 'Swiggy',
    testimonialText:
      'We recruited Manshi via Upraised for an APM role at Swiggy, and she really raised the bar in the interviews.',
    userAvatar: anujImg,
    companyLogo: swiggyImg,
    background: 'linear-gradient(90deg, #B1611F 0.71%, rgba(209, 112, 31, 0.6) 100%)',
  },
];

export const hireFaqsList = [
  {
    question: 'What are the roles available for full-time hiring?',
    response: () => <>At the moment, we can help with full-time hires for roles in Product Management.</>,
  },
  {
    question: 'What kind of background do candidates come from- education, work experience etc.?',
    response: () => (
      <>
        We have candidates from diverse educational & professional backgrounds: product managers, engineers, marketeers,
        consultants, and business professionals. We can help with hiring at all levels ranging from an APM/Jr PM to a Sr
        PM.
      </>
    ),
  },
  {
    question: 'What do candidates learn during the program?',
    response: () => (
      <>
        The Career Accelerator Program is a 16-week program which broadly covers topics ranging from Product
        Fundamentals to Specialisation for a PM type. In product fundamentals, we focus on strengthening the core skills
        required to become a good product manager. In specialization, we deep dive into areas such as Growth, Technical,
        Strategy etc. depending upon the candidate.
      </>
    ),
  },
  {
    question: 'What is the expected salary of candidates?',
    response: () => (
      <>
        As the candidates come from diverse educational & professional backgrounds, the salary expectation would vary
        depending on the candidate.
      </>
    ),
  },
  {
    question: 'What are the commercials involved in hiring from Upraised?',
    response: () => <>There are no commercials involved. Hiring from Upraised is free of cost.</>,
  },
];

export const hireValuePoints = [
  'Product Sense',
  'Result Orientation',
  'Technical Understanding',
  'Communication',
  'Problem Solving',
  'Data Drivenness',
];
